/*
 * Broadcast Theme — assets/custom.js
 *
 * HERCULE CUSTOM — refonte 2026.
 * Fichier activé via layout/theme.liquid (import décommenté).
 * Nettoyé le 2026-07-22 : l'exemple mort (YOUR_VARIANT_ID) jetait une
 * exception au chargement.
 */

(function () {
  // Add custom code below this line

  /* --------------------------------------------------------------------
   * Presse — autoplay des citations (section-press-logos / logos-component)
   *
   * logos.js n'autoplay les citations que lorsque les logos débordent du
   * viewport (flktyNav autoPlay 4 s). Quand tous les logos tiennent à
   * l'écran, seul le clic change la citation. Décision designer : rotation
   * automatique ~3 s dans tous les cas. On pilote le FlickityFade exposé
   * en `component.flkty` et on synchronise la classe `is-selected` du logo
   * actif ([data-slider-logos] [data-slide]). Pause au survol. Le timer se
   * suspend si l'autoplay natif est actif (logos en mode Flickity).
   * -------------------------------------------------------------------- */
  var PRESS_AUTOPLAY_INTERVAL = 3000;

  function initPressAutoplay(component) {
    if (component.dataset.herculeAutoplay) return;
    component.dataset.herculeAutoplay = 'true';

    var timer = null;

    function tick() {
      var flkty = component.flkty;
      if (!flkty || !flkty.cells || flkty.cells.length < 2) return;

      var nav = component.querySelector('[data-slider-logos]');
      // Logos en slider Flickity => autoplay natif (4 s) déjà en charge.
      if (nav && nav.classList.contains('flickity-enabled')) return;

      flkty.next(true);

      if (nav) {
        var index = flkty.selectedIndex;
        nav.querySelectorAll('[data-slide]').forEach(function (logo, i) {
          logo.classList.toggle('is-selected', i === index);
        });
      }
    }

    function start() {
      if (!timer) timer = setInterval(tick, PRESS_AUTOPLAY_INTERVAL);
    }

    function stop() {
      clearInterval(timer);
      timer = null;
    }

    component.addEventListener('mouseenter', stop);
    component.addEventListener('mouseleave', start);
    start();
  }

  function initAllPressAutoplay() {
    document.querySelectorAll('logos-component').forEach(initPressAutoplay);
  }

  /* --------------------------------------------------------------------
   * Grille produits à onglets
   *
   * Desktop : la grille affiche 3 rangées puis un bouton « Charger plus »
   * qui révèle le reste de la liste (puis pagine en AJAX), sans redirection.
   *
   * Mobile : slider allégé pour limiter le chargement de la home. On ne
   * garde que MOBILE_MAX cartes puis une carte « Voir tout » vers la
   * collection de l'onglet (à la place de la fin de liste). Les cartes
   * masquées (display:none) ne déclenchent jamais le lazy-load de leurs
   * images — seules les 6 premières se chargent.
   * -------------------------------------------------------------------- */
  var LOAD_MORE_LABEL = 'Charger plus';
  var SEE_ALL_LABEL = 'Voir tout';
  var MOBILE_MAX = 6; // cartes visibles dans le slider mobile avant « Voir tout »
  var API_SECTION = 'hercule-collection-grid-api';
  var API_PAGE_SIZE = 12;

  function initLoadMore() {
    document.querySelectorAll('.index-tab-collections .tab-content').forEach(function (tab) {
      if (tab.dataset.herculeLoadMore) return;
      tab.dataset.herculeLoadMore = 'true';

      var gridOuter = tab.querySelector('.grid-outer');
      if (!gridOuter) return;

      // Libellés traduits (products.general.load_more / see_all) passés en
      // data-attributes par section-tab-collections.liquid ; fallback FR.
      var loadMoreLabel = tab.dataset.loadMoreLabel || LOAD_MORE_LABEL;
      var seeAllLabel = tab.dataset.seeAllLabel || SEE_ALL_LABEL;

      // Collection de l'onglet : on part de l'URL rendue par le Liquid.
      // ⚠ ne PAS déduire le handle de l'ID du block : dans index.json les
      // blocks portent un nom libre — le block « all » pointe sur la
      // collection « all-products-in-stock », et /collections/all est une
      // toute autre liste (autre contenu, autre ordre, d'où les doublons).
      // L'URL Liquid porte aussi la racine de marché/locale (/uk/, /de/…).
      var collectionUrl = (tab.dataset.collectionUrl || '').split('?')[0];
      var apiUrl = collectionUrl
        ? collectionUrl + '?section_id=' + API_SECTION + '&page='
        : null;

      var mqMobile = window.matchMedia('(max-width: 749px)');
      var step = 12; // 3 rangées desktop
      var visible = step;
      // Offset AJAX : on repart du nombre de produits BRUTS déjà consommés par
      // la boucle Liquid, pas du nombre de cartes affichées (les produits
      // taggés « hide » occupent une place dans la collection sans être
      // rendus — compter les cartes décalerait la pagination).
      var serverLimit = parseInt(tab.dataset.serverLimit, 10) || 0;
      var productsCount = parseInt(tab.dataset.productsCount, 10) || 0;
      var consumed = Math.min(serverLimit, productsCount);
      var nextPage = Math.floor(consumed / API_PAGE_SIZE) + 1;
      var remoteExhausted = !apiUrl || consumed >= productsCount;
      var loading = false;

      // Garde-fou anti-doublon : si la fenêtre serveur n'est pas un multiple
      // de API_PAGE_SIZE (grille 3×5 = 15 par ex.), la page AJAX recouvre la
      // fin du rendu serveur — on écarte les produits déjà présents.
      var seen = Object.create(null);
      function productKey(item) {
        return (item.dataset.url || item.id || '').split('?')[0];
      }
      tab.querySelectorAll('.grid-outer .grid-item').forEach(function (item) {
        var key = productKey(item);
        if (key) seen[key] = true;
      });

      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'btn btn--text btn--black hercule-load-more';
      // <span> requis pour le hover natif Broadcast des .btn--text
      button.innerHTML = '<span>' + loadMoreLabel + '</span>';

      function items() {
        return tab.querySelectorAll('.grid-outer .grid-item');
      }

      // Carte « Voir tout » (dernière slide du carrousel mobile). Sa
      // visibilité est pilotée en CSS (masquée en desktop, affichée en
      // mobile) ; on l'insère en fin de grille pour qu'elle suive la
      // dernière carte visible (les cartes masquées ne prennent pas de place).
      var seeAllCard = null;
      function buildSeeAll() {
        var url = tab.dataset.collectionUrl;
        if (!url) return;
        // Même rendu que « Charger plus » : lien texte souligné (btn--text
        // btn--black), sans encadré. Le <span> porte le soulignement Hercule.
        var card = document.createElement('a');
        card.className = 'btn btn--text btn--black hercule-see-all-slide';
        card.href = url;
        card.innerHTML = '<span>' + seeAllLabel + '</span>';
        var grid = gridOuter.querySelector('.grid') || gridOuter;
        grid.appendChild(card);
        seeAllCard = card;
      }

      function apply() {
        var list = items();
        var mobile = mqMobile.matches;
        // Mobile : on ne garde que MOBILE_MAX cartes (le reste masqué → pas de
        // lazy-load). Desktop : logique « Charger plus » historique.
        list.forEach(function (item, i) {
          var show = mobile ? i < MOBILE_MAX : i < visible;
          item.style.display = show ? '' : 'none';
        });
        var done = visible >= list.length && remoteExhausted;
        button.style.display = mobile || done ? 'none' : '';
      }
      mqMobile.addEventListener('change', apply);

      function fetchMore() {
        if (loading || remoteExhausted) return Promise.resolve();
        loading = true;
        button.classList.add('is-loading');
        return fetch(apiUrl + nextPage)
          .then(function (r) { return r.ok ? r.text() : ''; })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            // Les items serveur vivent dans le conteneur .grid interne :
            // on ajoute au même endroit pour hériter du dimensionnement.
            var grid = gridOuter.querySelector('.grid') || gridOuter;
            doc.querySelectorAll('.grid-item').forEach(function (item) {
              var key = productKey(item);
              if (key && seen[key]) return;
              if (key) seen[key] = true;
              // La carte « Voir tout » reste la dernière slide du carrousel.
              grid.insertBefore(item, seeAllCard);
            });
            nextPage += 1;
            // Fin de collection : on se fie au marqueur paginate.next rendu
            // par la section API, pas au nombre de cartes reçues (une page
            // peut en renvoyer moins de 12 si des produits sont taggés « hide »).
            if (!doc.querySelector('[data-hercule-has-next]')) remoteExhausted = true;
          })
          .catch(function () { remoteExhausted = true; })
          .finally(function () {
            loading = false;
            button.classList.remove('is-loading');
          });
      }

      // Après dédoublonnage une page peut n'apporter que quelques cartes :
      // on enchaîne les pages jusqu'à remplir la rangée demandée.
      function fillTo(target) {
        if (items().length >= target || remoteExhausted) return Promise.resolve();
        return fetchMore().then(function () { return fillTo(target); });
      }

      button.addEventListener('click', function () {
        // Un clic pendant un fetch relancerait fillTo() alors que fetchMore()
        // rend la main immédiatement (loading) → boucle de micro-tâches.
        if (loading) return;
        visible += step;
        if (items().length >= visible) {
          apply();
        } else {
          fillTo(visible).then(apply);
        }
      });

      buildSeeAll();
      gridOuter.after(button);
      // Bouton « Charger plus » inutile si tout tient en 3 rangées (desktop) ;
      // le cap mobile + la carte « Voir tout » restent gérés par apply()/CSS.
      if (items().length <= step && remoteExhausted) {
        button.remove();
      }
      apply();
    });
  }

  // Vidéos produit dans les grilles (onglets home + pages collection).
  // - Desktop (survol dispo) : lecture AU SURVOL de la carte.
  // - Mobile (tactile) : autoplay de la carte VISIBLE à l'écran, façon feed
  //   (le thème Broadcast n'expose ce comportement in-view que pour les fonds de
  //   section <video-background> ; on réutilise ici le même pattern
  //   IntersectionObserver sur la <video> existante, sans dupliquer le markup).
  // Perf commune : <video preload="none"> masquée (display:none) tant qu'elle
  // n'est ni survolée ni en vue → ni poster ni vidéo chargés avant l'intention.
  var GRID_SELECTOR =
    '[data-section-type="collection"], [data-section-type="product-grid"]';

  function initHoverVideo() {
    // Desktop uniquement : au tactile (mobile), on garde le poster figé — pas de
    // lecture vidéo dans les cards de grille (demande Lena).
    if (!window.matchMedia || !window.matchMedia('(hover: hover)').matches) return;
    initHoverVideoDesktop();
  }

  // Desktop : délégation survol sur la grille (couvre les cartes « Charger plus »).
  function initHoverVideoDesktop() {
    document.querySelectorAll(GRID_SELECTOR).forEach(function (section) {
      if (section.hoverVideoBound) return;
      section.hoverVideoBound = true;

      section.addEventListener('mouseover', function (event) {
        var item = event.target.closest('.product-item');
        if (!item || !section.contains(item)) return;
        var video = item.querySelector('.product-item__hover-video');
        if (!video || video.dataset.playing) return;
        video.dataset.playing = '1';
        var played = video.play();
        if (played && played.catch) played.catch(function () {});
      });

      section.addEventListener('mouseout', function (event) {
        var item = event.target.closest('.product-item');
        if (!item) return;
        // Ignore les déplacements internes à la carte (mouseout rebondit)
        if (event.relatedTarget && item.contains(event.relatedTarget)) return;
        var video = item.querySelector('.product-item__hover-video');
        if (!video) return;
        delete video.dataset.playing;
        video.pause();
        try {
          video.currentTime = 0;
        } catch (err) {}
      });
    });
  }

  /* --------------------------------------------------------------------
   * Orbe (sélecteur pays/devise) — scroll des listes au doigt sur mobile
   *
   * Le sélecteur Orbe s'ouvre en modale par-dessus le drawer menu mobile.
   * Ce drawer a déjà engagé le scroll-lock du thème (lib scroll-lock : le
   * touchmove est bloqué partout SAUF dans les éléments marqués
   * [data-scroll-lock-scrollable] — c'est ainsi que le thème rend ses
   * propres drawers scrollables). Les listes déroulantes d'Orbe
   * (#orbeCountryList / langue), injectées dynamiquement et dépourvues de
   * ce marqueur, ne pouvaient donc pas défiler au doigt : 49 pays dans un
   * overflow:auto de 168px, scroll tactile intercepté → « je ne peux pas
   * descendre ». On pose le marqueur au touchstart (qui précède toujours
   * le touchmove que la lib inspecte) sur la liste Orbe réellement touchée.
   * Classes md-form__select__*__list stables de l'app. */
  var ORBE_SCROLLABLE_SELECTOR =
    '.md-form__select__country__list, .md-form__select__language__list';

  function initOrbeScrollFix() {
    if (window.__herculeOrbeScrollFix) return;
    window.__herculeOrbeScrollFix = true;
    document.addEventListener(
      'touchstart',
      function (e) {
        var target = e.target;
        if (!target || !target.closest) return;
        var list = target.closest(ORBE_SCROLLABLE_SELECTOR);
        if (list && !list.hasAttribute('data-scroll-lock-scrollable')) {
          list.setAttribute('data-scroll-lock-scrollable', '');
        }
      },
      { passive: true, capture: true }
    );
  }

  /* --------------------------------------------------------------------
   * Orbe — « Japan / 日本 » envoie chez le distributeur neph-jp.com
   *
   * Le Japon est vendu par un distributeur (Neph) qui a son propre site.
   * Le marché Shopify « Japon » est donc en brouillon, mais Orbe le liste
   * quand même dans son sélecteur de pays (entrée #orbe-country-JP rendue
   * côté serveur) : choisir « Japan » soumettait à Shopify un changement
   * de marché impossible, sans effet visible. Décision Lena 2026-10-20 :
   * ce choix ouvre la collection Hercule du distributeur.
   *
   * Deux interceptions en phase de capture (avant les gestionnaires
   * d'Orbe) : le clic ou Entrée sur l'entrée Japon de la liste, et la
   * validation du formulaire si le pays retenu est déjà JP (cas où Orbe
   * le propose de lui-même). Si Orbe cessait de lister le Japon, on
   * recrée l'entrée à partir d'une entrée existante (même balisage).
   * Les visiteurs détectés au Japon par leur adresse IP sont, eux,
   * redirigés plus tôt par le snippet hercule-redirect-japon.
   *
   * Cible /japon et non neph-jp.com : depuis le 2026-10-21 Shopify injecte
   * un « exit interstitial » qui intercepte toute navigation vers un domaine
   * extérieur (« Are you sure you want to leave Hercule Studio ? »). Une
   * navigation interne passe ; la redirection d'URL Shopify /japon →
   * https://www.neph-jp.com/collections/hercule-studio fait le saut côté
   * serveur, sans page intermédiaire (voir le snippet pour le détail).
   * -------------------------------------------------------------------- */
  var ORBE_JAPON_URL = '/japon';
  var ORBE_JAPON_NOM = 'Japan / 日本';
  var ORBE_JAPON_ENTREE = '#orbeCountryList [data-country="JP"]';

  function allerChezNeph(e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    window.location.href = ORBE_JAPON_URL;
  }

  function assurerEntreeJaponOrbe() {
    var liste = document.getElementById('orbeCountryList');
    if (!liste || liste.querySelector('[data-country="JP"]')) return;
    var modele = liste.querySelector('li[data-country]');
    if (!modele) return;
    var li = modele.cloneNode(true);
    li.id = 'orbe-country-JP';
    li.setAttribute('data-name', ORBE_JAPON_NOM);
    li.setAttribute('data-country', 'JP');
    var lien = li.querySelector('[data-country]');
    if (lien) {
      lien.setAttribute('data-country', 'JP');
      lien.setAttribute('data-value', 'JP');
      lien.setAttribute('data-countryname', ORBE_JAPON_NOM);
      lien.setAttribute('aria-current', 'false');
    }
    var libelle = li.querySelector('.md-form__select__span');
    if (libelle) libelle.textContent = ORBE_JAPON_NOM;
    var suivant = null;
    var entrees = liste.querySelectorAll('li[data-name]');
    for (var i = 0; i < entrees.length; i++) {
      if (entrees[i].getAttribute('data-name').localeCompare(ORBE_JAPON_NOM) > 0) {
        suivant = entrees[i];
        break;
      }
    }
    liste.insertBefore(li, suivant);
  }

  function initOrbeJapon() {
    if (window.__herculeOrbeJapon) return;
    window.__herculeOrbeJapon = true;

    document.addEventListener(
      'click',
      function (e) {
        if (!e.target || !e.target.closest) return;
        if (e.target.closest(ORBE_JAPON_ENTREE)) {
          allerChezNeph(e);
          return;
        }
        var pays = document.getElementById('orbe-country-selector-popup-id');
        if (e.target.closest('#md-btn__form__onSubmit') && pays && pays.value === 'JP') {
          allerChezNeph(e);
        }
      },
      true
    );

    document.addEventListener(
      'keydown',
      function (e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        if (e.target && e.target.closest && e.target.closest(ORBE_JAPON_ENTREE)) {
          allerChezNeph(e);
        }
      },
      true
    );

    document.addEventListener(
      'submit',
      function (e) {
        var pays = document.getElementById('orbe-country-selector-popup-id');
        if (e.target && e.target.id === 'md-modal__form__id' && pays && pays.value === 'JP') {
          allerChezNeph(e);
        }
      },
      true
    );

    assurerEntreeJaponOrbe();
    var modale = document.getElementById('md-app-embed__modal');
    if (modale && window.MutationObserver) {
      new MutationObserver(assurerEntreeJaponOrbe).observe(modale, { childList: true, subtree: true });
    }
  }

  function initAll() {
    initAllPressAutoplay();
    initLoadMore();
    initHoverVideo();
    initOrbeScrollFix();
    initOrbeJapon();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  // Sections rechargées dans l'éditeur de thème
  document.addEventListener('shopify:section:load', initAll);

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
